import React from 'react';

export function BrandLogo({ size = 32, className = '', segment }) {
  const isEldercare = segment === 'eldercare' || document.documentElement.getAttribute('data-segment') === 'eldercare';
  return (
    <img
      src={isEldercare ? '/logo-teal.png' : '/logo.png'}
      alt={isEldercare ? 'ElderCareConnections' : 'ChildCareConnections'}
      width={size}
      height={size}
      className={`rounded-xl ${className}`}
      style={{ objectFit: 'contain' }}
    />
  );
}
